cv.PublicPostsRowEmptyView = Marionette.LayoutView.extend({
  className: 'post-empty',
  template: cv.Templates['public/posts/posts_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PublicPostsRowEmptyView initialized');
  },

  onAttach: function(){
  }
});
